<div class="fms-walk-me-left-panel-list">
  <app-check-item-completed
    *ngFor="let row of rows"
    [label]="row.label"
    [active]="activeStep === row.index"
    [enable]="user.onboardingv2_step >= row.index"
    [checked]="onboardingProgress.isCompleted(row.key)"
    [required]="row.required"
    (onClick)="stepSelected.emit(row.index)"
    [step]="row.index"
  ></app-check-item-completed>
  <app-check-item-completed
    *ngIf="onboardingProgress.showFlyLearning"
    label="FlyLearning"
    [active]="activeStep === flyLearningStepIndex"
    [enable]="user.onboardingv2_step >= flyLearningStepIndex"
    [checked]="user.onboardingv2_step >= flyLearningStepIndex + 1"
    (onClick)="stepSelected.emit(flyLearningStepIndex)"
    [step]="flyLearningStepIndex"
  ></app-check-item-completed>
</div>
<div class="fms-walk-me-row" style="gap: 10px">
  <button
    vng-button
    variant="ghost"
    fullWidth
    type="button"
    class="fms-walk-me-more-learning-button"
    (click)="moreLearningVideos.emit()"
    data-fms-heap="walk-me-modal-more-learning-videos"
  >
    <!-- L3: size="24" is load-bearing. vng-icon renders the ligature at the
         INHERITED font-size when [size] is unset (its host binds
         `style.font-size.px` to the input), and this ghost button's
         font-size is 14px — so the play glyph came out ~14px and its
         outline read as a solid triangle. mat-icon (master) was always
         24px regardless of the button's text size. -->
    <vng-icon name="play_circle_outline" color="accent" size="24"></vng-icon>
    More learning videos
  </button>
</div>
